import React, { Component } from "react";
import AnonymousTournamentContainer from "./AnonymousTournamentContainer";
import { withRouter } from "react-router-dom";

class AnonymousContainer extends Component {
  state = {
    codeValid: null,
    iResCodeValid: null,
  };

  UNSAFE_componentWillMount = () => {
    if ((this.props.userData || {}).isPSD) {
      this.props.history.push("/");
    }
    if (this.props.psdCode) {
      fetch("https://tournify-server.herokuapp.com/checkPsdCode", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          psdCode: this.props.psdCode,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(
          function (payload) {
            let valid = payload.valid || false;
            if (valid === "used") {
              this.props.history.push("/");
            } else {
              this.setState({ codeValid: valid });
            }
          }.bind(this)
        );
    }

    if (this.props.iResCode) {
      fetch("https://tournify-server.herokuapp.com/checkIResCode", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          iResCode: this.props.iResCode,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(
          function (payload) {
            let valid = payload.valid || false;
            if (valid === "used") {
              this.props.history.push("/");
            } else {
              this.setState({ iResCodeValid: valid });
            }
          }.bind(this)
        );
    }

    if (this.props.user === undefined) {
      window.firebase
        .auth()
        .signInAnonymously()
        .catch(function (error) {
          // Handle Errors here.
          // var errorCode = error.code;
          // var errorMessage = error.message;
          // ...
        });
    }
  };

  getRefPromo = () => {
    const domain = ((window.location.hostname || "").split(".") || [])[
      ((window.location.hostname || "").split(".") || []).length - 1
    ];
    let ref = null;
    if (domain === "pl" || true) {
      let urlString = window.location.href;
      let url = new URL(urlString);
      ref = url.searchParams.get("ref");
    }
    return ref;
  };

  render() {
    let loaded = this.props.user && !(this.props.userData || {}).isPSD;
    if (this.props.psdCode) {
      loaded = this.props.user && this.state.codeValid !== null;
    }
    if (this.props.iResCode) {
      loaded = this.props.user && this.state.iResCodeValid !== null;
    }
    return loaded ? (
      <AnonymousTournamentContainer
        user={this.props.user}
        userData={this.props.userData}
        psdCode={this.props.psdCode}
        codeValid={this.state.codeValid}
        iResCode={this.props.iResCode}
        iResCodeValid={this.state.iResCodeValid}
        promo={this.getRefPromo()}
      />
    ) : (
      <div />
    );
  }
}

export default withRouter(AnonymousContainer);
